import request from '@/utils/request';

//新增有购买会员接口
export function getEmbedData(values) {
  return request('/getPbiToken', {
    method: 'POST',
    data: values,
  });
}
